"use client";
import { AnalyticsListTypes } from "@lib/analytics/analyticsTypes";
import type { CustomProductCarouselModel } from "@lib/contentful/mappers/modules/customProductCarousel/types";
import dynamic from "next/dynamic";
import type { FC } from "react";

const SearchProductsHitsToCarousel = dynamic(
    () =>
        import("@components/commerce/product/product-carousel/SearchProductHitsToCarousel").then(
            (mod) => mod.SearchProductsHitsToCarousel
        ),
    { ssr: false }
);

type CustomProductCarouselProps = CustomProductCarouselModel & { theme?: string };

export const CustomProductCarousel: FC<CustomProductCarouselProps> = ({
    header,
    skus,
    assistiveLabel,
    extraLink,
    theme,
}) => (
    <SearchProductsHitsToCarousel
        skus={skus}
        headline={header}
        assistiveMessage={assistiveLabel}
        carouselType={AnalyticsListTypes.custom}
        extraLink={extraLink}
        theme={theme}
    />
);
